import React from 'react'

export default function Statistics(){
    return (
      <div>
        统计
      </div>
    )
}
